/** Wait after completion, so slow requests never overlap. */
export function startQualityPolling(task: () => Promise<void>, delayMs = 3000) {
  let stopped = false
  let timer: ReturnType<typeof setTimeout>
  const tick = async () => {
    try {
      await task()
    } catch {
      // A transient failure is retried on the next interval.
    } finally {
      if (!stopped) timer = setTimeout(() => void tick(), delayMs)
    }
  }
  timer = setTimeout(() => void tick(), delayMs)
  return () => {
    stopped = true
    clearTimeout(timer)
  }
}
